<template>
  <div class="list">
    <el-col>
      <el-card class="searchCard" shadow="never">
        <el-form :inline="true" class="demo-inline-form" :model='searchForm'>
          <el-form-item label="乐刷商户号">
            <el-input v-model.trim='searchForm.merchantId' clearable></el-input>
          </el-form-item>
          <el-form-item label="直属代理商编号">
            <el-input v-model.trim='searchForm.agentId' clearable></el-input>
          </el-form-item>
          <el-form-item label="活动名称">
            <el-select  v-model='searchForm.wxActivityId' clearable>
              <el-option v-for="item in activityList" :label="item.wxName" :value="item.wxActivityId" :key="item.wxActivityId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="报名状态">
            <el-select v-model="searchForm.status" clearable>
              <el-option v-for="item in statusList" :label="item.text" :key="item.value" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="最近上报时间">
            <date-range-picker :value="[searchForm.startTime, searchForm.endTime]" @getChange="dateChange"></date-range-picker>
          </el-form-item>
          <el-form-item label="微信商户号">
            <el-input v-model.trim="searchForm.wxSubMchId" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <auth-button
              opt="search"
              :plain="true"
              icon="el-icon-search"
              @click.native="buttonSearch"
              :loading="checkLoading"
              label="查询"></auth-button>
            <auth-button
              opt="export"
              :plain="true"
              download="微信活动报名信息导出.csv"
              icon="el-icon-download"
              @click.native="buttonExport"
              label="导出"
              :loading="exportLoading"></auth-button>
            <auth-button
              opt="sign_up"
              :plain="true"
              @click.native="activitySign"
              label="报名"></auth-button>
          </el-form-item>
        </el-form>
      </el-card>
    </el-col>
    <el-col>
      <div class="info">
        已勾选{{this.checkedRowIds.length}}个商户&nbsp;
        <auth-button
          opt="clear"
          type="text"
          @click.native="clearSelected"
          label="清空选中"></auth-button>
        <auth-button
          opt="reSign"
          type="text"
          @click.native="reSign"
          label="批量重新报名"></auth-button>
      </div>
    </el-col>
    <el-card class="tableCard" shadow="never">
      <el-table  border
        v-loading="tableLoading"
        :data="list">
        <el-table-column
          align="center"
          width="55">
          <!-- eslint-disable-next-line vue/no-unused-vars -->
          <template slot="header" slot-scope="scope">
            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange" :disabled="checkAllDisabled"></el-checkbox>
          </template>
          <template slot-scope="scope">
            <el-checkbox
              :value="checkedRowIds.indexOf(scope.row.id) > -1"
              :disabled="scope.row.status != 2"
              @change="handleCheck(scope.row.id)"
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="merchantId"
          label="乐刷商户号"
          width="110"
          align="center">
        </el-table-column>
        <el-table-column
          prop="merchantName"
          label="商户简称"
          align="center">
        </el-table-column>
        <el-table-column
          prop="wxSubMchId"
          label="微信商户号"
          width="110"
          align="center">
        </el-table-column>
        <el-table-column
          prop="agentId"
          label="直属代理商(编号)"
          width="90"
          align="center">
        </el-table-column>
        <el-table-column
          prop="wxName"
          label="活动名称"
          align="center">
        </el-table-column>
        <el-table-column
          prop="status"
          label="报名状态"
          width="100"
          align="center">
          <template slot-scope="scope">
            <span>{{
              statusList.filter(item => {
                return item.value == scope.row.status
              })[0].text}}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="rejectReason"
          label="备注"
          align="center">
          <template slot-scope="scope">
            <span>{{scope.row.rejectReason || '-'}}</span>
            <!-- <span>{{parseRemark(scope.row)}}</span> -->
          </template>
        </el-table-column>
        <el-table-column
          prop="updateTime"
          label="申请通过时间/最近上报时间"
          width="120"
          align="center">
        </el-table-column>
        <el-table-column
          prop="action"
          label="操作"
          align="center"
          fixed="right"
          width="320"
          :context="_self">
          <template slot-scope="scope">
            <auth-button
              opt="edit"
              type="text"
              @click.native="editActivityData(scope.row)"
              v-show="[-1, 2].includes(parseInt(scope.row.status))"
              label="编辑"></auth-button>
            <auth-button
              opt="update"
              type="text"
              @click.native="updateState(scope.row)"
              v-show="parseInt(scope.row.status) === 0"
              label="更新报名状态"></auth-button>
            <auth-button
              opt="record"
              type="text"
              @click.native="getAuditInfo(scope.row)"
              label="报名记录"
              ></auth-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination @changePage="onChangeCurrentPage" :size="sizeOption" :count="searchForm.count" :page-no="searchForm.pageNo"></pagination>
    </el-card>
    <el-dialog v-if="recordDialogVisible" title="报名记录" :visible.sync="recordDialogVisible" size="small" @close="closeRecodeDialog" width="800px" v-loading="recordDialogLoading">
      <el-table
        v-loading="inlineTableLoading"
        :data="auditList"
        max-height="490"
      >
        <el-table-column
          type="index"
          :index="index=>inlinePageNo * 10 + index - 9"
          width="55"
          label="序号"
        >
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="上报时间"
          width="120"
          align="center">
        </el-table-column>
        <el-table-column
          prop="businessApplicationId"
          label="业务申请编号"
          align="center">
        </el-table-column>
        <el-table-column
          prop="applicationId"
          label="申请单号"
          align="center">
        </el-table-column>
        <el-table-column
          prop="auditResult"
          label="审核结果"
          align="center">
          <template slot-scope="scope">
            <span>{{
              statusList.filter(item => {
                return item.value == scope.row.status
              })[0].text}}
            </span>
        </template>
        </el-table-column>
        <el-table-column
          prop="rejectReason"
          label="审核备注"
          align="center">
          <template slot-scope="scope">
            <span>{{scope.row.rejectReason || '-'}}</span>
          </template>
        </el-table-column>
      </el-table>
      <pagination @changePage="onChangeCurrentPage" :size="this.inlinePageSize" v-if="inlineCount != 0" :count="inlineCount" :page-no="inlinePageNo"></pagination>
      <div class='remark'>
        审核驳回请根据审核备注完善信息：<br/>1.在【活动管理-微信活动报名】完善活动必要资料<br/>2.在【商户管理-全部商户】完善商户的基础信息
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button @click="recordDialogVisible = false">关 闭</el-button>
        </span>
    </el-dialog>
    <el-dialog
      v-if="signDialogVisible"
      title="活动报名"
      :visible.sync="signDialogVisible"
      size="small"
      @close="closeSignDialog"
      width="500px"
      :close-on-click-modal="false"
      v-loading="signDialogLoading">
      <el-form :model="signForm" :rules="formRules" ref="signForm" class="signForm">
        <el-form-item label="活动名称" style="padding-bottom: 10px" prop="wxActivityId">
          <el-select v-model="signForm.wxActivityId" placeholder="请选择">
            <el-option
              v-for="item in activityList"
              :key="item.wxActivityId"
              :label="item.wxName"
              :value="item.wxActivityId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="downloadFile">
          <div>
            <input type="file" id="file" @change="getFile($event)" style="display:none" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"/>
            <el-button type="primary" size="small" class="check" @click="getMultiFiles()">导入商户</el-button>
            <a :href="templateUrl" download>
              <div class="file-download-button">下载报名模板</div>
            </a>
            <p>仅支持.xls、.xlsx格式</p>
            <el-col v-if="multiFileName !== ''" class="hasSelect">
              <span>已选择: {{multiFileName}}</span>
              <i class="el-icon-remove removeIcon" @click="removeFile"></i>
            </el-col>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="signActivity" :loading="signButtonLoading">报名活动</el-button>
      </span>
    </el-dialog>
    <el-dialog title="批量导入完成" :visible.sync="importDialogVisible" center width="500px" :append-to-body="true">
      <p class="marginBtm">成功{{this.successNum}}条，失败{{this.failNum}}条</p>
      <el-table border size="small" :data="failData">
        <el-table-column prop="line" label="行数" width="50" align="center"></el-table-column>
        <el-table-column prop="merchantId" label="商户编号" width="120" align="center"></el-table-column>
        <el-table-column prop="wxSubMchId" label="微信商户号" width="110" align="center"></el-table-column>
        <el-table-column prop="status" label="状态" width="70" align="center"></el-table-column>
        <el-table-column prop="reason" label="失败原因"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="importDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
    <el-dialog title="重新报名" :visible.sync="reSignDialogVisible" center width="500px" :append-to-body="true">
      <p class="marginBtm">成功{{resignSuccessNum}}条，失败{{resignFailNum}}条</p>
      <el-table border size="small" :data="resignFailData">
        <el-table-column prop="merchantId" label="商户编号" width="120" align="center"></el-table-column>
        <el-table-column prop="error_msg" label="失败原因"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="reSignDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import qs from 'qs'
import pagination from '@/components/pagination'
import dateRangePicker from '@/components/dateRangePicker'
import { getWechatActivityList, getWechatMerchantList, batchSignActivity, reSignActivity, updateAuditState, getWechatAuditList, exportWechatActivity } from '@/api/activity'
export default {
  name: 'activitySign',
  components: {
    pagination,
    dateRangePicker
  },
  data () {
    return {
      searchForm: {
        merchantId: '',
        wxMerchantId: '',
        agentId: '',
        // FBelongsAgentId: '',
        activeName: '',
        status: '', //
        pageNo: 1,
        Count: 0,
        startTime: '',
        endTime: ''
      },
      activityForm: {
        merchantId: '',
        agentId: '',
        // FBelongsAgentId: '',
        activeName: '',
        status: '',
        pageNo: 1,
        Count: 0
      },
      activityList: [],
      multiFile: '',
      multiFileName: '',
      checkLoading: false, // 查询按钮
      tableLoading: false, // 表格加载
      signButtonLoading: false, // 报名活动按钮
      inlinePageNo: 1,
      inlineCount: 0,
      inlinePageSize: 10,
      singleMerchantId: '',
      list: [], // 信息列表
      auditList: [], // 审核信息列表
      options: [], // 活动选项
      salesNum: 0, // 条数
      agentId: '',
      recordDialogVisible: false,
      signDialogVisible: false,
      importDialogVisible: false,
      reSignDialogVisible: false,
      resignFailData: [],
      resignSuccessNum: 0,
      resignFailNum: 0,
      failData: [],
      successNum: 0,
      failNum: 0,
      statusList: [{
        text: '待上报',
        value: -1
      }, {
        text: '审核中',
        value: 0
      }, {
        text: '审核通过',
        value: 1
      }, {
        text: '审核驳回',
        value: 2
      }],
      signForm: {
        wxActivityId: ''
      },
      formRules: {
        wxActivityId: [{
          required: true,
          message: '请选择活动名称',
          trigger: 'change'
        }],
        downloadFile: [{
          validator: (rule, value, callback) => {
            if (this.multiFile === '') {
              callback(new Error('请上传文件'))
            } else {
              callback()
            }
          }
        }]
      },
      signDialogLoading: false,
      recordDialogLoading: false,
      submitLoading: false,
      exportLoading: false,
      multipleSelection: [],
      checkedRowIds: [],
      isIndeterminate: false,
      checkAll: false,
      sizeOption: 10,
      isFrontAgent: false,
      templateUrl: 'static/微信费率活动报名模板.xls',
      checkAllDisabled: false
    }
  },
  mounted () {
    this.getUserInfo()
    this.getActivityList()
    this.getList()
  },
  methods: {
    /**
       * @description 搜索点击
       */
    buttonSearch () {
      this.checkLoading = true
      this.searchForm.pageNo = 1
      this.searchForm.Count = 0
      this.checkedRowIds = []
      this.getList()
    },
    /**
       * @description 改变当前页事件
       * @param  {number} page 当前页码
       */
    onChangeCurrentPage (page) {
      var totalCount = this.salesNum
      this.searchForm.pageNo = page
      this.searchForm.Count = totalCount
      this.getList()
    },
    // getRowKey
    /**
       * 日期选中事件
       */
    dateChange (value) {
      [this.searchForm.startTime, this.searchForm.endTime] = value
    },
    handleCheck (rowId) {
      if (this.checkedRowIds.indexOf(rowId) > -1) {
        this.checkedRowIds.splice(this.checkedRowIds.indexOf(rowId), 1)
      } else {
        this.checkedRowIds.push(rowId)
      }
      this.checkAllStatus()
    },
    checkAllStatus () {
      let count = 0
      let totalCount = 0
      this.list.map(item => {
        if (this.checkedRowIds.indexOf(item.id) > -1) {
          count += 1
        }
        if (parseInt(item.status) === 2) {
          totalCount += 1
        }
      })
      if (count === 0) {
        if (this.checkedRowIds.length > 0) {
          this.isIndeterminate = true
        } else {
          this.isIndeterminate = false
        }
        this.checkAll = false
      } else if (count === totalCount) {
        this.isIndeterminate = false
        this.checkAll = true
      } else {
        this.isIndeterminate = true
        this.checkAll = false
      }
    },
    handleCheckAllChange () {
      this.isIndeterminate = false
      // checkAll 已修改
      if (!this.checkAll) {
        this.list.map(item => {
          const index = this.checkedRowIds.indexOf(item.id)
          if (index > -1) {
            this.checkedRowIds.splice(index, 1)
          }
        })
        if (this.checkedRowIds.length > 0) {
          this.isIndeterminate = true
        }
      } else {
        this.list.map(item => {
          const id = item.id
          if (this.checkedRowIds.indexOf(id) < 0 && parseInt(item.status) === 2) {
            this.checkedRowIds.push(id)
          }
        })
      }
    },
    getActivityList () {
      getWechatActivityList({}).then((data) => {
        if (parseInt(data.error_code) !== 0) {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
        } else {
          this.activityList = data.data.activityInfoList
        }
      })
    },
    /**
       * @description 获取列表
       */
    getList () {
      this.tableLoading = true
      let data = this.formatSearch(this.searchForm)
      data = qs.stringify(data)
      getWechatMerchantList(data).then((data) => {
        this.checkLoading = false
        if (parseInt(data.error_code) !== 0) {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
          this.tableLoading = false
        } else {
          this.tableLoading = false
          this.searchForm.count = data.totalCount
          this.list = data.list
          this.salesNum = data.totalCount
          this.checkAllDisabled = data.list.filter(item => { return parseInt(item.status) === 2 }).length === 0
          this.checkAllStatus()
        }
      })
    },
    editActivityData (row) {
      // 目前 默认值 联调修改
      const query = {
        id: row.id
      }
      this.$router.push({
        path: '/Activity/ActivitySignin/wechatActivityEdit',
        query: query
      })
    },
    /**
       * @description 商户报名活动
       */
    signActivity () {
      this.signButtonLoading = true
      // 批量发布
      this.$refs.signForm.validate((valid) => {
        if (valid) {
          const data = new FormData()
          data.append('multipartFile', this.multiFile)
          data.append('wxActivityId', this.signForm.wxActivityId)
          batchSignActivity(data).then((data) => {
            this.signButtonLoading = false
            if (parseInt(data.error_code) !== 0) {
              this.$message({
                showClose: true,
                message: data.error_msg || data.result_msg,
                type: 'error'
              })
            } else if (data.fail_num === 0 && data.success_num === 0) {
              this.$message({
                showClose: true,
                message: '导入失败，请输入合适数据',
                type: 'error'
              })
            } else {
              this.successNum = data.success_num
              if (data.fail_num === 0) {
                this.$message({
                  showClose: true,
                  message: data.error_msg + '，成功导入' + data.success_num + '条',
                  type: 'success'
                })
              } else {
                this.importDialogVisible = true
                this.failNum = data.fail_num
                this.failData = data.result
              }
              this.signDialogVisible = false
            }
          })
        } else {
          this.signButtonLoading = false
          return false
        }
      })
    },
    clearSelected () {
      this.checkedRowIds = []
      this.checkAll = false
      this.isIndeterminate = false
    },
    /**
       * @description 重新报名
       * @prams {object} row 列表行对象
       */
    reSign () {
      const that = this
      if (that.checkedRowIds.length === 0) {
        that.$message({
          type: 'warning',
          message: '请选择至少一个商户重新提交'
        })
        return
      }
      const data = qs.stringify({ idList: that.checkedRowIds.join(',') })
      reSignActivity(data).then((data) => {
        if (parseInt(data.error_code) !== 0) {
          that.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
        } else {
          that.searchForm.pageNo = 1
          that.searchForm.Count = 0
          that.checkedRowIds = []
          that.getList()
          if (data.fail_num === 0) {
            that.$message({
              showClose: true,
              message: data.error_msg + '，成功导入' + data.success_num + '条',
              type: 'success'
            })
          } else {
            this.reSignDialogVisible = true
            that.resignFailData = data.result
            that.resignSuccessNum = data.success_num
            that.resignFailNum = data.fail_num
          }
          that.$message({
            showClose: true,
            message: data.error_msg,
            type: 'success'
          })
        }
      })
    },
    /**
       * @description 更新单个列表的状态
       */
    updateState (row) {
      const data = qs.stringify({ id: row.id })
      updateAuditState(data).then(response => {
        if (parseInt(response.error_code) === 0) {
          this.$message({
            message: response.error_msg,
            type: 'success'
          })
        } else {
          this.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
        this.getList()
      })
    },
    getMultiFiles () {
      this.$jquery('#file').click()
    },
    /**
       * @description 选择文件
       */
    getFile (event) {
      const name = event.target.files[0].name.split('.')
      if (!['xls', 'xlsx'].includes(name[name.length - 1])) {
        this.$message({
          message: '请上传.xls/.xlsx格式的文件！',
          type: 'warning'
        })
        return
      }
      if (Math.round(event.target.files[0].size / 1024 / 1024 * 100) / 100 > 1) {
        this.$message({
          message: '文件大小不得大于1M，请重新上传！',
          type: 'warning'
        })
      }
      this.multiFile = event.target.files[0]
      this.multiFileName = this.multiFile.name
      event.target.value = null
    },
    /**
       * @description 删除已上传文件
       */
    removeFile () {
      this.$confirm('是否确认删除文件？', '提示', {}).then(() => {
        this.multiFile = ''
        this.multiFileName = ''
      })
    },
    /**
       * @description 清除对象中无值属性
       * @param  {object} search 需要格式化的对象
       */
    formatSearch (search) {
      var data = Object.assign({}, search)
      for (var s in data) {
        if (!data[s] && data[s] !== 0) {
          delete data[s]
        }
      }
      return data
    },
    /**
       * @description 获取用户信息
       */
    getUserInfo () {
      this.agentId = this.$store.getters.userId
    },

    getAuditInfo (row) {
      this.recordDialogVisible = true
      this.inlineTableLoading = true
      const data = qs.stringify({
        merchantId: row.merchantId,
        wxActivityId: row.wxActivityId,
        pageNo: this.inlinePageNo,
        pageSize: this.inlinePageSize
      })
      getWechatAuditList(data).then((data) => {
        if (parseInt(data.error_code) === 0) {
          this.auditList = data.data.list
          this.inlineCount = data.data.totalCount
          this.inlineTableLoading = false
        } else {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
          this.inlineTableLoading = false
        }
      })
    },
    /**
       * @description 关闭弹窗
       */
    closeRecodeDialog () {
      this.recordDialogVisible = false
    },
    /**
       * @description 关闭弹窗
       */
    closeSignDialog () {
      this.recordDialogVisible = false
    },
    /**
       * 导出按钮
       */
    buttonExport () {
      // 当点击查询时，显示第一页
      this.searchForm.pageNo = 1
      this.exportLoading = true
      this.exportList()
    },
    activitySign () {
      this.signDialogVisible = true
    },
    exportList () {
      var data = this.formatSearch(this.searchForm)
      data = qs.stringify(data)
      exportWechatActivity(data).then(response => {
        this.exportLoading = false
        const nowDate = new Date()
        const timeString = nowDate.getFullYear() + '' +
                        (((nowDate.getMonth() + 1) < 10) ? ('0' + (nowDate.getMonth() + 1)) : (nowDate.getMonth() + 1)) +
                        ((nowDate.getDate() < 10) ? ('0' + nowDate.getDate()) : (nowDate.getDate())) +
                        ((nowDate.getHours() < 10) ? ('0' + nowDate.getHours()) : (nowDate.getHours())) +
                        ((nowDate.getMinutes() < 10) ? ('0' + nowDate.getMinutes()) : (nowDate.getMinutes())) +
                        ((nowDate.getSeconds() < 10) ? ('0' + nowDate.getSeconds()) : (nowDate.getSeconds()))
        // 弹出下载框
        const url = window.URL.createObjectURL(new Blob([response]))
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', '微信活动报名信息_' + this.agentId + '_' + timeString + '.csv')
        document.body.appendChild(link)
        link.click()
      }).catch(() => {
      })
    }
    // parseRemark (row) {
    //   if (row.rejectReason) {
    //     if (parseInt(row.status) === 2) {
    //       return row.rejectReason
    //     } else if (parseInt(row.status) === -1) {
    //       return '资料待完善，请及时补充'
    //     } else if (parseInt(row.status) === 0) {
    //       return '请耐心等待1~2 个工作日，微信支付将会完成审核'
    //     }
    //   }
    //   return '-'
    // }
  }
}
</script>

<style scoped>
  .alert{
    color: #00b0e8;
  }
  .hasSelect{
    font-size: 15px;
    margin-top: 20px;
  }
  .hasSelect span{
    float: left;
    margin-bottom: 20px;
    line-height: 30px;
    display: inline-block;
    max-width: 430px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .hasSelect .removeIcon{
    color:#F56C6C;
    line-height: 30px;
    cursor: pointer;
    margin-left: 10px;
  }
  .list{
    padding-left: 16px;
  }
  .remark {
    margin: 10px 0 0 10px;
    line-height:150%;
  }
  .signForm .el-form-item{
    margin-bottom: 10px;
  }
  .el-select-dropdown__item{
    max-width: 300px;
  }
  .file-download-button {
    color: #409eff;
    margin: 0 10px;
    display: inline-block;
  }
  .info {
    font-size: 15px;
    margin: 0 10px 10px 0;
    vertical-align: center;
  }
</style>
